import React from "react";
import { IconDocumentLinedGrid } from "../../../../../../../components/buttons/IconButtons";
/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 **/

export const GLOBAL_DEDUCTIONS_RESOURCE = 'GLOBAL_DEDUCTIONS';

const getTabsById = (tabs) => (id) => {
    const hasId = id !== null && id !== undefined;
    return Object.values(tabs)
        .filter(e => typeof e === 'object' && e.key !== undefined)
        .filter(e => hasId || e.key === 0);
};

export const GLOBAL_DEDUCTIONS_TABS = {
    EXCLUDE_DEDUCTIONS: {
        key: 0,
        name: "EXCLUDE_DEDUCTIONS",
        translation: "exclude_deductions",
        icon: <IconDocumentLinedGrid width={24} height={24} />,
    },
    DEDUCTIONS_EXCLUDED: {
        key: 1,
        name: "DEDUCTIONS_EXCLUDED",
        translation: "deductions_excluded",
        icon: <IconDocumentLinedGrid width={24} height={24} />,
    },
    getTabsById: getTabsById({}),
};
GLOBAL_DEDUCTIONS_TABS.getTabsById = getTabsById(GLOBAL_DEDUCTIONS_TABS);
